import React from 'react';
import {Button, ButtonGroup} from 'react-bootstrap';
import Braces from '@mui/icons-material/DataObjectRounded';
import Cpu from '@mui/icons-material/MemoryRounded';
import InfoCircle from '@mui/icons-material/InfoRounded';
import NodePlus from '@mui/icons-material/HubRounded';

const TABS = [
  {
    key: 'tree',
    label: 'Tree',
    Icon: NodePlus,
    helpUrl: 'https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Standortstruktur',
  },
  {
    key: 'device',
    label: 'Devices',
    Icon: Cpu,
    helpUrl: 'https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Ger%C3%A4tedefinition',
  },
  {
    key: 'json',
    label: 'JSON',
    Icon: Braces,
    helpUrl: 'https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Json-Editor',
  },
];

const ConfigModeTabs = ({configMode, setConfigMode}) => (
  <div className="float-start config-tabs">
    <ButtonGroup>
      {TABS.map(({key, label, Icon, helpUrl}) => (
        <Button key={key} active={configMode === key} onClick={() => setConfigMode(key)}>
          <Icon/> {label}{' '}
          <a href={helpUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
            <InfoCircle style={{fontSize: 14}}/>
          </a>
        </Button>
      ))}
    </ButtonGroup>
  </div>
);

export default ConfigModeTabs;

